import { ApiBaseCall } from "../../../utils/apiCall";
import { openLink } from "../../utils/openLink";

const initialState = {
  isFetching: false
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "thinkific.signin.isFetching":
      return { ...state, isFetching: true };

    case "thinkific.signin.fetchSuccess":
      return { ...state, isFetching: false, ...action.response };

    case "thinkific.signin.fetchError":
      return { ...state, isFetching: false, ...action.response };

    default:
      return state;
  }
}

// Actions
export function generateSsoUrl(target, academyUrl = "") {
  return dispatch => {
    dispatch({ type: "thinkific.signin.isFetching" });
    ApiBaseCall.post(
      `/thinkific/signin?return_to=https://academy.spocket.co/${academyUrl}`
    )
      .then(response => {
        // Redirecing the user for the thinkific_login_url
        openLink(response.json.thinkific_login_url, target);

        // Saving the response into our Redux store
        dispatch({
          type: "thinkific.signin.fetchSuccess",
          response: response.json
        });
      })
      .catch(error => {
        dispatch({ type: "thinkific.signin.fetchError", error });
      });
  };
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/thinkific/signin.js